"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.loading.title': 'Activando tu cuenta',
    'activate.loading.message': 'Por favor espera mientras activamos tu cuenta...',
};
